// @flow
import { all, fork, put, takeEvery, call } from 'redux-saga/effects';

import {
    getNoticias as listNoticiasAPI,
    getNoticia as getNoticiaAPI,
    addNoticia as addNoticiaAPI,
    updateNoticia as updateNoticiaAPI,
    deleteNoticia as deleteNoticiaAPI,
} from '../../helpers/';

// import { APICore, setAuthorization } from '../../helpers/api/apiCore';
import { noticiasApiResponseError, noticiasApiResponseSuccess } from './actions';
import { NoticiasActionTypes } from './constants';

// const api = new APICore();

/**
 * Get contacto
 * @param {*} payload - username and password
 */
function* getNoticia({ payload: { id } }) {
    try {
        const response = yield call(getNoticiaAPI, id );
        const noticiaItem = response.data.data;
        yield put(noticiasApiResponseSuccess(NoticiasActionTypes.GET_NOTICIA, noticiaItem));
    } catch (error) {
        yield put(noticiasApiResponseError(NoticiasActionTypes.GET_NOTICIA, error));
    }
}

function* addNoticia({payload:noticia}){
    try{
        const response = yield call(addNoticiaAPI,{...noticia})
        const noticiaItem = response.data
        yield put(noticiasApiResponseSuccess(NoticiasActionTypes.ADD_NOTICIA,noticiaItem))
    } catch(error){
        yield put(noticiasApiResponseError(NoticiasActionTypes.ADD_NOTICIA,error))
    }
}

function* updateNoticia({payload:noticia}){
    try{
        const response = yield call(updateNoticiaAPI,{...noticia})
        const noticiaItem = response.data.data
        yield put(noticiasApiResponseSuccess(NoticiasActionTypes.UPDATE_NOTICIA,noticiaItem))
    }catch(error){
        yield put(noticiasApiResponseError(NoticiasActionTypes.UPDATE_NOTICIA,error))
    }
}
function* deleteNoticia({payload:{id}}){
    try{
        const response = yield call(deleteNoticiaAPI,id)
        const noticiaItem = response.data.id
        yield put(noticiasApiResponseSuccess(NoticiasActionTypes.DELETE_NOTICIA,noticiaItem))
    }catch(error){
        yield put(noticiasApiResponseError(NoticiasActionTypes.DELETE_NOTICIA,error))
    }
}

/**
 * List contactos
 */
function* listNoticias({payload:params}) {
    try {
        const response = yield call(listNoticiasAPI, { ...params });
        const listaNoticias = response.data.data;
        yield put(noticiasApiResponseSuccess(NoticiasActionTypes.LIST_NOTICIAS, listaNoticias));
    } catch (error) {
        yield put(noticiasApiResponseError(NoticiasActionTypes.LIST_NOTICIAS, error));
    }
}


export function* watchGetNoticia(): any {
    yield takeEvery(NoticiasActionTypes.GET_NOTICIA, getNoticia);
}

export function* watchListNoticias(): any {
    yield takeEvery(NoticiasActionTypes.LIST_NOTICIAS, listNoticias);
}

export function* watchAddNoticia():any{
    yield takeEvery(NoticiasActionTypes.ADD_NOTICIA,addNoticia)
}
export function* watchUpdateNoticia():any{
    yield takeEvery(NoticiasActionTypes.UPDATE_NOTICIA,updateNoticia)
}
export function* watchDeleteNoticia():any{
    yield takeEvery(NoticiasActionTypes.DELETE_NOTICIA,deleteNoticia)
}


function* noticiasSaga(): any {
    yield all([
        fork(watchGetNoticia),
        fork(watchListNoticias),
        fork(watchAddNoticia),
        fork(watchUpdateNoticia),
        fork(watchDeleteNoticia),
    ]);
}

export default noticiasSaga;
